export default __webpack_public_path__ + "static/media/lib-1.a5f50fbb.webp";